import { render } from "./BalanceDisplayControl.vue?vue&type=template&id=ec1dcc06"
import script from "./BalanceDisplayControl.vue?vue&type=script&lang=js"
export * from "./BalanceDisplayControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__